import React from "react";
import moment from "moment";
import { PropTypes } from "prop-types";
import { Grid } from "semantic-ui-react";
import { Button, Modal, Dimmer, Loader } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import {
  socketEvents,
  socketEventEmitter
} from "../../utilities/socketioClient";

import {
  getDepartments,
  getProductService,
  getVendors,
  getClasses,
  deleteProductService,
  putProductService,
  postProductService,
  getSubclasses,
  getNrfcolors,
  createItemProduct,
  geTicketType,
  putVendorCommitment,
  getPreferredTicketType,
  getRequestHeadersByIdService,
  getCompareAtSources,
  getSizeGroupsInfoForDepartment,
  getPOStatus
} from "../../services/offpriceServices";

import DataGrid from "./DataGrid";
import TopPanel from "./TopPanel";
import SharedModal from "../../utilities/SharedModal";
import { createWorkSheetFromExcelRows } from "../../utilities/worksheet";
import { sharedState } from "../../utilities/sharedState";
import { EventListener } from "../../utilities/eventListener";
import {
  columnValidators,
  headerFieldsValidators
} from "../../utilities/validators";

import {
  getMetadata,
  resetProductServerErrorMsgsAndDirtyState,
  formatProductColumns
} from "./util";
import { toast } from "../../utilities/toast";
import {
  updateComputedColumns,
  computeProductsSummary
} from "../../utilities/computations";
import Footer from "./Footer";
import sortBy from "lodash/sortBy";
import { isoToStr } from "../../utilities/date";
import _ from "lodash";


const NEW_WORKSHEET_ID = "new";

export default class ProductDetail extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      lastModalOpen: false
    }
    this.eventListener = new EventListener();
    this.initialize();
    _.bindAll(
      this,
      "handleDeleteProduct",
      "handleClickCreateOrder",
      "loadGridData",
      "loadPoNumber"
    );
  }

  openLastModal = () =>  {
    this.setState({
      lastModalOpen: true
    });
  }
  closeLastModal = () => {
    this.setState({
      lastModalOpen: false
    });
  }

  // // for debugging
  // setState(transformer, callback) {
  //   return React.Component.prototype.setState.call(this, transformer, (...args) => {
  //     console.log(this.state)
  //     return typeof callback === 'function' ? callback(...args) : null
  //   })
  // }

  initialize(afterFn) {
    const nextState = {
      isNewWorksheet: this.props.worksheetId === NEW_WORKSHEET_ID,
      worksheetId: this.props.worksheetId,
      rowsHasValidationErrors: false,
      worksheetName: "",
      worksheet: {
        POIdentifier: []
      },
      department: null,
      vendor: null,
      departments: [],
      vendors: [],
      dataHasBeenModified: false,
      requestHeaderID: "",
      response: [],
      isSaving: false,
      isLoading: false,
      nfrcolors: [],
      ticketType: [],
      compareatsources: [],
      preTicket: [
        { id: 0, value: "Y", text: "Y", title: "Y" },
        { id: 1, value: "N", text: "N", title: "N" }
      ],
      preTicketValue: "N",
      purchaseOrderNumber: "",
      purchaseOrderDescription: "",
      vendorNotes: "",
      MaycsNetRouteDate: "",
      CancelDate: "",
      IndcDate: "",
      DistroByDate: "",
      showDetailView: false,
      showDeleteModal: false,
      //showContinueModal: false,
      productIndexToDelete: void 0,
      productToDelete: void 0,
      isDeletingProduct: false,
      inputErrors: {}, // {inputName: 'Error Message'}
      signedIn: "",
      ticketTypeValue: null,
      dynamicMutableObjectForDataTableEditors: {
        classes: [],
        subclasses: [],
        nfrcolors: [],
        ticketType: [],
        compareatsources: []
      },
      isVendorUpcMode: false,
      WrkSheetTypeId: 1,
      POIdentifier: [],
      isDisabled: false
    };

    if (this.hasBeenMounted) {
      this.setState(nextState, afterFn);
    } else {
      this.state = nextState;
      afterFn && afterFn();
    }

    this.newWorkSheetHasBeenCreated = false;
  }

  loadPoNumber() {
    let worksheetid = _.get(this, "state.worksheetId");
    let DeptNo = _.get(this, "state.department");
    let VendorNo = _.get(this, "state.vendor");
    
    return getRequestHeadersByIdService(worksheetid, DeptNo, VendorNo).then(res => {
      this.setState(prev => ({
        ...prev,
        purchaseOrderNumber: _.get(res, "data.PurchaseOrderNumber")
      }));
    });
  }

  handleWorksheetEditMode = (deptNo, vendorNo) => {
    //call orderStatus service in place of this session storage 
    //sessionStorage.setItem('orderStatus', 'distro');
    let worksheetid = _.get(this, "state.worksheetId");
    getPOStatus(worksheetid, deptNo,vendorNo).then(response => {
      let data = response.data;
      if(sessionStorage.getItem('updateEnabled') === 'false') {
        localStorage.setItem('isEditable', false);
        this.setState({isDisabled: true});  
      } else {
        //replace switch condition with the value from orderService response
        switch(data.statusCode) {
          case 'open-rcpt':
          case 'canceled': {
            localStorage.setItem('isEditable', false);
            this.setState({isDisabled: true, isLoading: false, orderStatus: data.statusDesc, worksheet: {
              ...this.state.worksheet,
              POIdentifier: []
            }});
            this.loadGridDataWithCondition(true);
            break;
          }
          case 'distro-complete':
          case 'partially-allocated': this.setState({showContinueModal: true, isLoading:false, worksheet: {
            ...this.state.worksheet,
            POIdentifier: []
          }}); break;
          default: localStorage.setItem('isEditable', true);  
          this.setState({isDisabled: false, isLoading: false, orderStatus:'PO can be updated', worksheet: {
            ...this.state.worksheet,
            POIdentifier: []
          }});
          this.loadGridDataWithCondition(false);        
        }
      }
     
       
        
    });
   
  }

  loadGridDataWithCondition = (isDisabled) =>{
    let worksheetid = _.get(this, "state.worksheetId");
    const maybeAddDeleteButton = (prod, idx) => {
      if(isDisabled)
      {
      return {
        ...prod,
        Delete:
          <Button
            icon="trash alternate"
            size="tiny"
            fluid
            compact
            onClick={() => this.handleDeleteProduct(idx, prod)}
            disabled
          />
      };
    }
    else
    {
      return {
        ...prod,
        Delete:
          <Button
            icon="trash alternate"
            size="tiny"
            fluid
            compact
            onClick={() => this.handleDeleteProduct(idx, prod)}
          />
      };
    }
    
    };

    return getProductService(worksheetid).then(response => {
      let data = response.data;
      data.savedDepartment = data.DeptNo ? String(data.DeptNo) : null;
      data.savedVendor = data.VendorNo ? String(data.VendorNo) : null;
      this.setState({
         
        purchaseOrderNumber: _.get(data, "PurchaseOrderNumber"),
        worksheet: {
          ...data,
          Products: _.chain(data)
            .get("Products")
            .map(maybeAddDeleteButton)
            .map(updateComputedColumns)
            .map(formatProductColumns)
            .thru(this.addMetadataToProducts)
            .sortBy("ImportRowNo")
            .value()
        }
      });
    });
  }

  loadGridData() {
    let worksheetid = _.get(this, "state.worksheetId");
    const maybeAddDeleteButton = (prod, idx) => {
      return {
        ...prod,
        Delete:
          <Button
            icon="trash alternate"
            size="tiny"
            fluid
            compact
            onClick={() => this.handleDeleteProduct(idx, prod)}
            disabled={this.state.lastModalOpen === true}
          />
      };
    };

    return getProductService(worksheetid).then(response => {
      let data = response.data;
      this.setState({
        purchaseOrderNumber: _.get(data, "PurchaseOrderNumber"),
        worksheet: {
          ...data,
          Products: _.chain(data)
            .get("Products")
            .map(maybeAddDeleteButton)
            .map(updateComputedColumns)
            .map(formatProductColumns)
            .thru(this.addMetadataToProducts)
            .sortBy("ImportRowNo")
            .value()
        }
      });
    });
  }

  loadMainData() {
    getCompareAtSources().then(res => {
      const compareatsources = res.data.map(
        ({ CompareAtSourceCode, CompareAtSource }) => ({
          id: CompareAtSourceCode,
          value: CompareAtSourceCode,
          text: CompareAtSourceCode + "-" + CompareAtSource
        })
      );

      this.setState(prev => ({
        compareatsources,
        dynamicMutableObjectForDataTableEditors: {
          ...prev.dynamicMutableObjectForDataTableEditors,
          compareatsources
        }
      }));
    });

    getNrfcolors().then(res => {
      // const nfrcolors = res.data.map(({ nrfColorNo, nrfColorName }) => ({
      //   id: nrfColorNo,
      //   value: nrfColorNo,
      //   text: nrfColorNo + "-" + nrfColorName
      // }));
      const nfrcolors = _.chain(res)
      .get("data")
      .map(({ RowKey, Desc }) => ({
        value: RowKey,
        text: RowKey + "-" + Desc
      }))
      .value();
      

      this.setState(prev => ({
        nfrcolors,
        signedIn: res.status,
        dynamicMutableObjectForDataTableEditors: {
          ...prev.dynamicMutableObjectForDataTableEditors,
          nfrcolors
        }
      }));
    });

    geTicketType().then(res => {
      const ticketType = res.data.map(({ ticketTypeCode, ticketTypeDesc }) => ({
        id: ticketTypeCode,
        value: ticketTypeCode,
        text: ticketTypeCode + "-" + ticketTypeDesc
      }));

      ticketType.unshift({
        text: "",
        title: ""
      });

      this.setState({
        ticketType
      });
    });

    let tempPOIdentifiers=[];
    // load worksheet content
    this.setState(
      state => ({
        ...state,
        isLoading: true
      }),
      () => {
        (this.state.isNewWorksheet
          ? Promise.resolve(
              createWorkSheetFromExcelRows(
                sharedState.importedExcelRows,
                sharedState.importedExcelMappings
              )
            ).then(data => ({ data }))
          : getProductService(this.state.worksheetId)
        ).then(response => {
          let data = response.data;
          let loadingStatus = false;
          localStorage.setItem('isEditable', true);
          if(data.WrkSheetTypeId !== 2 
            && (data.StatusCode === 'poidentifierupdated' 
            || data.StatusCode === 'poidentifierupdateerror'))
            {
            this.handleWorksheetEditMode(data.DeptNo, data.VendorNo);
            loadingStatus= true;
            }
                                
          data.savedDepartment = data.DeptNo ? String(data.DeptNo) : null;
          data.savedVendor = data.VendorNo ? String(data.VendorNo) : null;
          tempPOIdentifiers = data.POIdentifier;
          let validProductsUniqKey = _.chain(data)
            .get("Products")
            .map("ImportRowNo")
            .countBy()
            .values()
            .max()
            .thru(v => _.eq(v, 1))
            .value();
          this.setState(
            prevState => ({
              worksheet: {
                ...data,
                POIdentifier:[],
                TempPOIdentifier:data.POIdentifier,
                Products: this.addMetadataToProducts(
                  _.chain(data)
                    .get("Products")
                    .map(p => ({
                      ...p,
                      isVendorUpcMode: data.IsVendorUpcMode || false
                    }))
                    .map((p, i) =>
                      validProductsUniqKey ? p : { ...p, ImportRowNo: i }
                    )
                    .map(p => ({
                      ...p,
                      EachesOrPacks: _.get(p, "EachesOrPacks", "eaches")
                    }))
                    .map(updateComputedColumns)
                    .map(formatProductColumns)
                    .sortBy("ImportRowNo")
                    .value()
                )
              },
              ticketTypeValue: data.Products.length
                ? data.Products[0].TicketType
                : null,
              worksheetName: data.RequestHeaderName || "",
              department: data.DeptNo ? String(data.DeptNo) : null,
              vendor: data.VendorNo ? String(data.VendorNo) : null,
              isLoading: loadingStatus,
              preTicketValue: data.PreTicket || "N",
              vendorNotes: data.VendorNotes,
              purchaseOrderNumber: data.PurchaseOrderNumber || "",
              purchaseOrderDescription: data.PoDesc || "",
              MaycsNetRouteDate: isoToStr(data.MaycsNetRouteDate),
              CancelDate: isoToStr(data.CancelDate),
              IndcDate: isoToStr(data.IndcDate),
              DistroByDate: isoToStr(data.DistroByDate),
              isVendorUpcMode: data.IsVendorUpcMode || false
            }),
            () =>
              getDepartments().then(res => {
                if (res) {
                  //const department = departments && departments.length ? departments[0].value : null

                  this.setState(
                    state => {
                      const departments = _.chain(res)
                        .get("data")
                        .map(({ RowKey, DeptName }) => ({
                          value: RowKey,
                          text: RowKey + "-" + DeptName
                        }))
                        .value();

                      departments.unshift({
                        text: "",
                        title: ""
                      });

                      let departmentId = null;
                      if (departments && departments.length) {
                        const department =
                          departments.find(v => v.value === state.department) ||
                          departments[0];
                        departmentId = department && department.value;
                      }

                      return {
                        department: departmentId,
                        departments: departments
                      };
                    },
                    () =>
                      this.onChangeDepartment(null, {
                        value: this.state.department
                      })
                  );
                }
              })
          );
        }).then(()=>{
            this.setState({...this.state,worksheet:{...this.state.worksheet, POIdentifier: this.state.worksheet.TempPOIdentifier}});
        });
        
      }
    );
    
  }

  componentDidUpdate(prevProps) {
    if (this.props.worksheetId !== prevProps.worksheetId) {
      this.initialize(() => this.loadMainData());
    }
  }

  componentWillMount() {
    this.hasBeenMounted = false;
  }

  componentDidMount() {
    this.hasBeenMounted = true;
    this.loadMainData();
    this.eventListener.subscribeTo(socketEventEmitter);
    this.eventListener
      .getEventEmitter()
      .on(socketEvents.poheadercreated, this.loadPoNumber)
      .on(socketEvents.pocreated, this.loadGridData)
      .on(socketEvents.pdfitemcreated, this.loadGridData)
      .on(socketEvents.pdfitemcreateerror, this.loadGridData)
      .on(socketEvents.poidentifiersupdateerror, () => {
        this.setState({
          dataHasBeenModified: true,
          isSaving: false
        });
      });
  }

  componentWillUnmount() {
    _.invoke(socketEventEmitter, "removeAllListeners");
    this.eventListener.unsubscribe();
  }

  closeContinueModal = () => {
    this.setState({showContinueModal: false});
  }

  changeStyle = () => {
    var all = document.getElementsByClassName("react-grid-Row");
    for (var i = this.state.fromRow; i <= this.state.toRow; i++) {
      all[i].style.color = this.state.cellUpdateCss;
    }
  };

  /**
   * This function, even tho is called add *metadata*, all it does is to assign errors to the fields on each product.
   * @param products
   * @returns {(*|{metadata: *})[]}
   */
  addMetadataToProducts = (products = []) => {
    const metadata = getMetadata(products);
    products = products.map((row, idx) => ({
      ...row,
      metadata: metadata[idx]
    }));
    return products;
  };

  handleClickAddNewRow = () => {
    this.setState(state => {
      const newProduct = {
        Quantity: "0",
        Cost: "00.00",
        TicketRetail: "00.00",
        MbksStyleSeq: 1,
        MultiOf: 1,
        EachesOrPacks: "eaches",
        TicketType: _.get(state, "ticketTypeValue"),
        ImportRowNo: _.chain(state)
          .get("worksheet.Products")
          .map("ImportRowNo")
          .map(v => _.toNumber(v || 0))
          .max()
          .defaultTo(-1)
          .thru(v => v + 1)
          .value(),
        Delete: (
          <Button
            icon="trash alternate"
            size="tiny"
            fluid
            compact
            onClick={() =>
              this.handleDeleteProduct(state.worksheet.Products.length)
            }
            disabled={this.state.lastModalOpen === true}
          />
        )
      };

      const Products = [...state.worksheet.Products, newProduct];

      return {
        ...state,
        worksheet: {
          ...state.worksheet,
          Products
        }
      };
    });
  };

  handleRowsUpdated = update => {
    const { data: updated } = update;
    const cellKey = _.get(update, "colDef.field");
    const dataset = _.chain(update)
      .get("api")
      .invoke("getModel")
      .get("rowsToDisplay")
      .map("data")
      .value();
    const validity = _.invoke(
      columnValidators,
      `${cellKey}.getValidity`,
      updated[cellKey],
      updated,
      dataset,
      this.state.isVendorUpcMode
    );

    if (!_.invoke(validity, "isValid")) {
      const msgs = _.invoke(validity, "getErrorMessages");
      if (!_.isEmpty(msgs)) {
        toast({
          type: "error",
          title: "Error",
          description: _.first(msgs)
        });
      }
    }

    this.setState(state => {
      return {
        ...state,
        dataHasBeenModified: true,
        worksheet: {
          ...state.worksheet,
          Products: _.chain([...state.worksheet.Products])
            .map(p =>
              _.eq(_.get(p, "ImportRowNo"), _.get(updated, "ImportRowNo"))
                ? { ...p, ...updated }
                : p
            )
            .map(_.curry(updateComputedColumns, 2)(_, state))
            .map(formatProductColumns)
            .thru(this.addMetadataToProducts)
            .value()
        }
      };
    });
  };

  handleClickSave = () => {
    const clearBlankValue = v => (Number(v) === -1 ? void 0 : v);

    const request = {
      ...this.state.worksheet,
      DeptNo: clearBlankValue(this.state.worksheet.DeptNo),
      VendorNo: clearBlankValue(this.state.worksheet.VendorNo),
      Products: this.state.worksheet.Products.map(prod => ({
        ...prod,
        MbksClass: clearBlankValue(prod.MbksClass),
        MbksSubClass: clearBlankValue(prod.MbksSubClass),
        TicketType: clearBlankValue(prod.TicketType),
        TicketTypeDesc:
          Number(prod.TicketType) === -1 ? void 0 : prod.TicketTypeDesc,
        CompareAtSource: clearBlankValue(prod.CompareAtSource)
      })),
      RequestHeaderName: this.state.worksheetName,
      MaycsNetRouteDate: this.state.MaycsNetRouteDate,
      CancelDate: this.state.CancelDate,
      IndcDate: this.state.IndcDate,
      DistroByDate: this.state.DistroByDate,
      PreTicket: clearBlankValue(this.state.preTicketValue),
      PurchaseOrderNumber: this.state.purchaseOrderNumber,
      PoDesc: this.state.purchaseOrderDescription,
      VendorNotes: this.state.vendorNotes,
      IsVendorUpcMode: this.state.isVendorUpcMode,
      WrkSheetTypeId: this.state.WrkSheetTypeId,
      POIdentifier: JSON.stringify(this.state.POIdentifier)
    };
    
    if (this.state.isNewWorksheet) {
      const selectedVendor =
        this.state.vendors.find(vendor => vendor.value === this.state.vendor) ||
        {};

      request.POIdentifier = JSON.stringify(_.chain(selectedVendor).toPairs()
          .filter(p => /^POId[\d]+Default$/.test(_.first(p)))
          .map(a => ({POIdNbr: _.replace(_.first(a), /^POId([\d]+)Default$/, "$1"), POIdValue: _.last(a)})).value());

      this.setState({ isSaving: true });

      postProductService(request)
        .then(response => {
          if (response.status == 201) {
            this.newWorkSheetHasBeenCreated = true;
            //First time upload XL sheet message.
            toast({
              type: "success",
              title: "Success",
              description: "Successfully Saved.!"
            });
            response.data.savedDepartment = response.data.DeptNo ? String(response.data.DeptNo) : null;
            response.data.savedVendor = response.data.VendorNo ? String(response.data.VendorNo) : null;
            this.setState({
              worksheet: response.data,
              dataHasBeenModified: false,
              isSaving: false,
              isNewWorksheet: false
            });
          } else {
            if (response.response.status == 412) {
              // BBPC-160: display validation message from response
              this.handleValidationFromResponse(response.response, true);
            } else {
              toast({
                type: "error",
                title: "Error",
                description:
                  "Unable to save your data due to technical difficulties"
              });
            }
            this.setState({
              isSaving: false
            });
          }
        })
        .catch(() => {
          toast({
            type: "error",
            title: "Error",
            description:
              "Unable to save your data due to technical difficulties"
          });
          this.setState({
            isSaving: false
          });
        });
    } else {
      // update
      this.setState({ isSaving: true });

      putProductService(request)
        .then(response => {
          if (response.status == 200) {
            toast({
              type: "success",
              title: "Success",
              description: response.data
            });
            this.loadMainData();
            this.setState({ isSaving: false, dataHasBeenModified: false });
          } else {
            if (response.response.status == 412) {
              // BBPC-160: display validation message from response
              this.handleValidationFromResponse(response.response);
            } else {
              const msg =
                response.data && response.data.code === "InvalidInput"
                  ? response.data.message
                  : "Unable to save your data due to technical difficulties";
              toast({
                type: "error",
                title: "Error",
                description: msg
              });
            }
            this.setState({
              isSaving: false
            });
          }
        })
        .catch(() => {
          toast({
            type: "error",
            title: "Error",
            description:
              "Unable to save your data due to technical difficulties"
          });
          this.setState({
            isSaving: false
          });
        });
    }
  };

  handleClickVendorCommitment = () => {
    const RequestHeaderId = this.state.worksheetId;
    const data = {
      RequestHeaderName: this.state.worksheetName,
      DeptNo: this.state.department,
      VendorNo: this.state.vendor,
      MaycsNetRouteDate: this.state.MaycsNetRouteDate,
      IndcDate: this.state.IndcDate,
      CancelDate: this.state.CancelDate,
      DistroByDate: this.state.DistroByDate,
      PreTicket: this.state.preTicketValue,
      Products: this.state.worksheet.Products,
      PurchaseOrderNumber: this.state.purchaseOrderNumber,
      PoDesc: this.state.purchaseOrderDescription,
      VendorNotes: this.state.vendorNotes,
      WrkSheetTypeId: 1
    };
    this.setState(
      state => ({
        ...state,
        isSaving: true
      }),
      () =>
        putVendorCommitment(RequestHeaderId, data)
          .then(response => {
            let blob = new Blob([response.data], { type: "application/pdf" });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob); // for IE
            } else {
              /* const fileURL = URL.createObjectURL(blob);
         window.open(fileURL);*/
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = "file.pdf";
              link.click();
            }

            if (response && response.status == 200) {
              toast({
                type: "success",
                title: "Success",
                description: response.data
              });
              const newProducts = resetProductServerErrorMsgsAndDirtyState(
                this.state.worksheet.Products
              );
              this.setState(state => ({
                ...state,
                dataHasBeenModified: false,
                isSaving: false,
                worksheet: {
                  ...state.worksheet,
                  Products: newProducts
                }
              }));
            } else {
              const msg =
                response.data && response.data.code === "InvalidInput"
                  ? response.data.message
                  : "Unable to save your data due to technical difficulties";
              toast({
                type: "error",
                title: "Error",
                description: msg
              });
              this.setState({
                isSaving: false
              });
            }
          })
          .catch(res => {
            if (res && res.response && res.response.status == 412) {
              // BBPC-160: display validation message from response
              let ab = res.response.data;
              var buf = new Buffer(ab.byteLength);
              var view = new Uint8Array(ab);
              for (var i = 0; i < buf.length; ++i) {
                buf[i] = view[i];
              }
              var jsonString = new TextDecoder("utf-8").decode(buf);
              const data = JSON.parse(jsonString);
              res.response.data = data;
              this.handleValidationFromResponse(res.response);
            } else {
              toast({
                type: "error",
                title: "Error",
                description:
                  "Unable to save your data due to technical difficulties"
              });
            }
            this.setState({
              isSaving: false
            });
          })
    );
  };

  handleClickCreateOrder = () => {
    const fieldLabels = {
      RequestHeaderName: "Worksheet Name",
      DeptNo: "Department",
      VendorNo: "Vendor",
      MaycsNetRouteDate: "MacysNet Route Date",
      IndcDate: "In DC Date",
      CancelDate: "Cancel Date",
      DistroByDate: "Distro By Date",
      PreTicket: "Pre-Ticket",
      TicketType: "Ticket Type",
      VendorUpc: "Vendor UPC"
    };

    const data = {
      RequestHeaderName: this.state.worksheetName,
      DeptNo: this.state.department,
      VendorNo: this.state.vendor,
      MaycsNetRouteDate: this.state.MaycsNetRouteDate,
      IndcDate: this.state.IndcDate,
      CancelDate: this.state.CancelDate,
      DistroByDate: this.state.DistroByDate,
      PreTicket: this.state.preTicketValue,
      Products: this.state.worksheet.Products,
      PurchaseOrderNumber: this.state.purchaseOrderNumber,
      PoDesc: this.state.purchaseOrderDescription,
      VendorNotes: this.state.vendorNotes,
      TicketType: this.state.ticketTypeValue,
      IsVendorUpcMode: this.state.isVendorUpcMode,
      WrkSheetTypeId: this.state.WrkSheetTypeId,
      POIdentifier: JSON.stringify(this.state.POIdentifier)
    };

    let hasErrors = false;

    // Header values validation
    Object.keys(data).forEach(fieldName => {
      const fieldValue = data[fieldName];
      const validator = headerFieldsValidators[fieldName];
      if (validator) {
        const validity = validator.getValidity(fieldValue);
        if (!validity.isValid()) {
          hasErrors = true;
          const msg = validity.getErrorMessages();
          toast({
            type: "error",
            title: "Error",
            description: fieldLabels[fieldName] + " " + msg[0]
          });
        }
      }
    });

    if (hasErrors) {
      return;
    }

    // Grid columns validation
    const prodWithError = this.state.worksheet.Products.find(product => {
      return Object.keys(product.metadata).find(colName => {
        return product.metadata[colName].hasErrors();
      });
    });

    if (prodWithError) {
      toast({
        type: "error",
        title: "Error",
        description:
          "Some of your products has invalid values, please provide valid data"
      });
      return;
    }

    createItemProduct(this.state.worksheetId, data).then(resp => {
      if (_.eq(_.get(resp, "status"), 200)) {
        //TBD
        toast({
          type: "success",
          title: "Success",
          description: resp.data
        });
      } else {
        this.handleValidationFromResponse(_.get(resp, "response", {}));
      }
    });
  };

  handleValidationFromResponse(resp, isNewWorksheet) {
    if (!_.get(resp, "data.isValid")) {
      const data = resp.data;

      if (!_.isEmpty(_.get(data, "validationMessages"))) {
        data.validationMessages.forEach(m => {
          toast({
            type: "error",
            title: "Error",
            description: m.errorMessage
          });
        });
      } else {
        toast({
          type: "error",
          title: "Error",
          description: "Invalid product data"
        });
      }

      if (!_.isEmpty(_.get(data, "products"))) {
        const newProducts = _.chain(this)
          .get("state.worksheet.Products")
          .map(p => ({ ...p, serverErrors: void 0 }))
          .map(p => {
            const found = isNewWorksheet
              ? _.find(data.products, { importRowNo: p.ImportRowNo })
              : _.find(data.products, { productId: p.ProductId });

            const msgs = _.get(found, "validationMessages", []);
            return { ...p, serverErrors: msgs };
          })
          .value();

        this.setState(state => ({
          ...state,
          worksheet: {
            ...state.worksheet,
            Products: newProducts
          }
        }));
      }
    } else {
      this.setState(state => ({
        ...state,
        worksheet: {
          ...state.worksheet,
          Products: _.chain(this)
            .get("state.worksheet.Products")
            .map(p => ({ ...p, serverErrors: void 0 }))
            .value()
        }
      }));
    }
  }

  onChangeWorksheetName = e => {
    const value = e.target.value;
    this.setState(state => ({
      dataHasBeenModified: value !== state.dataHasBeenModified,
      worksheetName: value
    }));
  };

  handleDeleteProduct(idx, product) {
    
    if(this.state.worksheet.Products.length <= '1'){

      this.setState({
        lastModalOpen: true,
      });

    }else{

      this.setState({
        showDeleteModal: true,
        productIndexToDelete: idx,
        productToDelete: product
      });

    }
  }

  handleUpdateProducts = yes => () => {
    this.setState({showContinueModal: false});
    if(yes) {
      this.setState({isDisabled: false, orderStatus: 'PO can be updated'});
      this.loadGridDataWithCondition(false);
      return localStorage.setItem('isEditable', true);
    } 
    this.setState({isDisabled: true,orderStatus: 'Allocated'});
    this.loadGridDataWithCondition(true);
    return localStorage.setItem('isEditable', false);
    
  }

  handleAcceptToDeleteProduct = yes => () => {
    this.setState(
      {
        isDeletingProduct: true
      },
      () => {
        const idx = this.state.productIndexToDelete;
        const idxProd = _.chain(this)
          .get("state.worksheet.Products")
          .find({ ImportRowNo: idx })
          .value();
        const product = this.state.productToDelete || idxProd || {};
        const resetDeleteState = {
          showDeleteModal: false,
          productIndexToDelete: void 0,
          productToDelete: void 0,
          isDeletingProduct: false
        };

        if (yes) {
          if (
            product.ProductId === void 0 &&
            product.RequestHeaderId === void 0
          ) {
            this.setState(state => {
              const Products = _.chain(state)
                .get("worksheet.Products")
                .reject({ ImportRowNo: idx })
                .value();
              return {
                ...state,
                worksheet: {
                  ...state.worksheet,
                  Products
                },
                ...resetDeleteState
              };
            });
          } else {
            deleteProductService(
              product.RequestHeaderId,
              product.ProductId,
              this.state.department,
              this.state.vendor
            ).then(res => {
              if (res.status == 200) {
                this.setState(state => {
                  const Products = state.worksheet.Products.filter(
                    prod => prod.ProductId !== product.ProductId
                  );
                  toast({
                    type: "success",
                    title: "Product tagged for deletion",
                    description: res.data && res.data.message
                  })
                  return {
                    ...state,
                    worksheet: {
                      ...state.worksheet,
                      Products
                    },
                    ...resetDeleteState
                  };
                });
              } else {
                this.setState(resetDeleteState, () =>
                  toast({
                    type: "error",
                    title: "Error",
                    description: res.data && res.data.message
                  })
                );
              }
            });
          }
        } else {
          this.setState(resetDeleteState);
        }
      }
    );
  };

  onChangeDepartment = (__, { value }) => {
    const sizeGroups = getSizeGroupsInfoForDepartment(value).then(
      sizeGroups => {
        console.log(`SizeGroups for department ${value}`, sizeGroups);
      }
    );

    const dataHasBeenModified =
      !_.isNil(_.get(this, "state.department")) &&
      !_.isEqual(_.get(this, "state.department"), value);

    this.setState(
      {
        department: value
      },
      () =>
        getVendors(value).then(res => {
          if (res) {
            this.setState(
              state => {
                let vendors = sortBy(
                  res.data.map(vendor => _.chain({})
                      .extend(vendor, {value: vendor.RowKey, text: vendor.RowKey + "-" + vendor.Desc})
                      .omit(["Timestamp", "Desc", "RowKey", "PartitionKey"]).value()),
                  v => Number(v.value)
                );

                vendors = [_.chain(vendors).first().cloneDeep().extend({text: "", title: ""}).omit("value").value(), ...vendors];

                return {
                  dataHasBeenModified:
                    dataHasBeenModified || _.get(state, "dataHasBeenModified"),
                  vendors: vendors,
                  worksheet: {
                    ...state.worksheet,
                    DeptNo: value,
                    Products: state.worksheet.Products.map((prod, idx) => ({
                      ...updateComputedColumns(prod),
                      DeptNo: value,
                      Delete:
                        // prod.StatusCode === statusCode.Complete ? (
                        //   ""
                        // ) : (
                          <Button
                            icon="trash alternate"
                            size="tiny"
                            fluid
                            compact
                            onClick={() => this.handleDeleteProduct(idx, prod)}
                            disabled={this.state.lastModalOpen === true || this.state.isDisabled}
                          />
                        //)
                    }))
                  }
                };
              },
              () => {
                const vendors = this.state.vendors;
                if (vendors && vendors.length) {
                  const vendor =
                    vendors.find(v => v.value === this.state.vendor) ||
                    vendors[0];
                  this.onChangeVendor(null, vendor, dataHasBeenModified);
                }
              }
            );
          }
        })
    );

    // load classes
    Promise.all([
      getClasses(value),
      getSubclasses(value),
      getSizeGroupsInfoForDepartment(value)
    ]).then(([classesResp, subclassesResp, sizeGroupsResp]) => {
      let newClasses = [];
      let newSubClasses = [];
      let newsizeGroups = [];

      if (classesResp) {
        newClasses = _.map(classesResp.data, ({ RowKey, Desc }) => ({
          id: RowKey,
          key: RowKey,
          value: RowKey,
          text: RowKey + "-" + Desc,
          title: RowKey
        }));
      }

      if (subclassesResp) {
        newSubClasses = _.map(subclassesResp.data, ({ RowKey, Desc }) => ({
          id: RowKey,
          key: RowKey,
          value: RowKey,
          text: RowKey + "-" + Desc,
          title: RowKey
        }));
      }

      if (sizeGroupsResp) {
        newsizeGroups = _.map(
          sizeGroupsResp.data,
          ({ sizeGroupCode, sizeGroupDesc, packs, sizes }) => {
            return {
              id: sizeGroupCode,
              key: sizeGroupCode,
              value: sizeGroupCode,
              text: `${sizeGroupCode} - ${sizeGroupDesc}`,
              title: sizeGroupCode,
              packs,
              sizes
            };
          }
        );
      }

      // if department is blank just set it up
      if (value === void 0) {
        this.setState(state => {
          return {
            ...state,
            classes: newClasses,
            subclasses: newSubClasses,
            sizegroups: newsizeGroups
          };
        });
      } else {
        this.setState(state => {
          const newProducts = state.worksheet.Products.map(prod => {
            const cls = newClasses.find(a => a.value == prod.MbksClass);
            const subcls = newSubClasses.find(
              a => a.value == prod.MbksSubClass
            );

            const MbksClass = cls ? cls.value : prod.MbksClass;
            const MbksSubClass = subcls ? subcls.value : prod.MbksSubClass;

            return {
              ...prod,
              MbksClass,
              MbksSubClass
            };
          });

          return {
            ...state,
            classes: newClasses,
            subclasses: newSubClasses,
            sizegroups: newsizeGroups,
            worksheet: {
              ...state.worksheet,
              Products: newProducts
            }
          };
        });
      }

      // important
      this.setState(prev => ({
        dynamicMutableObjectForDataTableEditors: {
          ...prev.dynamicMutableObjectForDataTableEditors,
          classes: newClasses,
          subclasses: newSubClasses,
          sizegroups: newsizeGroups
        }
      }));
    });
  };

  onChangeVendor = (__, { value }, dataHasBeenModified = true) => {
    this.setState(state => ({
      dataHasBeenModified:
        dataHasBeenModified || _.get(state, "dataHasBeenModified"),
      vendor: value,
      worksheet: {
        ...state.worksheet,
        VendorNo: value,
        Products: state.worksheet.Products.map(prod => ({
          ...prod,
          VendorNo: value
        }))
      }
    }));

    if (dataHasBeenModified && _.get(this, "state.worksheet.DeptNo")) {
      getPreferredTicketType(_.get(this, "state.worksheet.DeptNo"), value).then(
        res => {
          this.onChangeTicketType(
            null,
            { value: _.get(res, "data.ticketTypeCode", -1) },
            dataHasBeenModified
          );
        }
      );
    }
  };

  computeProductsSummary() {
    const prods =
      this.state.worksheet && this.state.worksheet.Products
        ? this.state.worksheet.Products
        : [];
    return computeProductsSummary(prods);
  }

  onChangeDate = dateName => (_, { value }) => {
    this.setState(state => ({
      ...state,
      [dateName]: value,
      dataHasBeenModified:
        state[dateName] !== value || _.get(state, "dataHasBeenModified")
    }));
  };

  onChangePreTicket = (event, { value }) => {
    this.setState(state => ({
      ...state,
      preTicketValue: value,
      dataHasBeenModified:
        value !== state.preTicketValue || _.get(state, "dataHasBeenModified")
    }));
  };

  onChangePurchaseOrderNumber = (event, { value }) => {
    this.setState(state => ({
      ...state,
      purchaseOrderNumber: value,
      dataHasBeenModified:
        value !== state.purchaseOrderNumber ||
        _.get(state, "dataHasBeenModified")
    }));
  };

  onChangePurchaseOrderDescription = (event, { value }) => {
    this.setState(state => ({
      ...state,
      purchaseOrderDescription: value,
      dataHasBeenModified:
        value !== state.purchaseOrderDescription ||
        _.get(state, "dataHasBeenModified")
    }));
  };

  onChangeVendorNotes = (event, { value }) => {
    this.setState(state => ({
      ...state,
      vendorNotes: value,
      dataHasBeenModified:
        value !== state.vendorNotes || _.get(state, "dataHasBeenModified")
    }));
  };

  handleToggleViewDetail = () => {
    this.setState({
      showDetailView: !this.state.showDetailView
    });
  };

  onChangeTicketType = (
    event,
    { value: ticketTypeValue },
    dataHasBeenModified
  ) => {
    this.setState(state => ({
      ...state,
      ticketTypeValue,
      dataHasBeenModified:
        dataHasBeenModified || ticketTypeValue !== state.ticketTypeValue,
      worksheet: {
        ...state.worksheet,
        Products: state.worksheet.Products.map(prod => ({
          ...prod,
          TicketType: ticketTypeValue
        }))
      }
    }));
  };

  onChangeVendorUPC = () => {
    this.setState(prevState => ({
      ...prevState,
      isVendorUpcMode: !prevState.isVendorUpcMode,
      worksheet: {
        ...prevState.worksheet,
        Products: _.chain([...prevState.worksheet.Products])
          .map(product => {
            let resetData = {
              EachesOrPacks: product.EachesOrPacks,
              TotalPacks: product.TotalPacks,
              SizeGroupCode: product.SizeGroupCode
            };

            if (!prevState.isVendorUpcMode) {
              resetData = {
                EachesOrPacks: "eaches",
                TotalPacks: "",
                SizeGroupCode: undefined
              };
            }

            return {
              ...product,
              ...resetData
            };
          })
          .map(_.curry(updateComputedColumns, 2)(_, prevState))
          .map(formatProductColumns)
          .thru(this.addMetadataToProducts)
          .value()
      }
    }));
  };

  handlePOIdentifierChange = POIdentifierData => {
    const POIdentifier = Object.entries(POIdentifierData).reduce(
      (acc, [key, value]) => {
        let parsedValue = value;

        if (_.isBoolean(value)) {
          return [
            ...acc,
            {
              POIdNbr: key,
              POIdValue: value ? "Y" : "N"
            }
          ];
        }

        if (_.isDate(value)) {
          return [
            ...acc,
            {
              POIdNbr: key,
              POIdValue: moment(value).format("MM/YY")
            }
          ];
        }

        return [...acc, { POIdNbr: key, POIdValue: value }];
      },
      []
    );

    this.setState(
      state => {
        return {
          dataHasBeenModified:
            (!_.isEmpty(state.POIdentifier) &&
              !_.isEqual(state.POIdentifier, POIdentifier)) ||
            _.get(state, "dataHasBeenModified"),
          POIdentifier
        };
      },
      () => {
        //handle updates based on this PO identifier change
        _.chain([
          { id: "4", fn: val => this.onChangePreTicket(null, { value: val }) }
        ])
          .each(({ id, fn }) => {
            const val = _.chain(this)
              .get("state.POIdentifier")
              .find({ POIdNbr: id })
              .get("POIdValue")
              .value();
            if (!_.isNil(val)) {
              fn.call(this, val);
            }
          })
          .value();
      }
    );
  };

  render() {
    const productsSummary = this.computeProductsSummary();
    if (this.newWorkSheetHasBeenCreated) {
      this.newWorkSheetHasBeenCreated = false;
      return (
        <Redirect to={`/products/${this.state.worksheet.RequestHeaderId}`} />
      );
    }

    const disablePurchaseOrderNumber = () => {
      const po = this.state.worksheet.PurchaseOrderNumber;
      return po !== void 0 && po !== "" && po !== null;
    };

    return (
    <React.Fragment>
      {this.state.isLoading ? (
        <Dimmer active inverted inline="centered">
        <Loader />
      </Dimmer>
      ):
     <Grid padded>
       <Grid.Row>
          <Grid.Column>
          <SharedModal
              open={this.state.lastModalOpen}
              onClose={this.closeLastModal}
              header="Delete Product"
              content="Delete not allowed for last row."
            />
          <SharedModal
              open={this.state.showDeleteModal}
              ifOngoing={this.state.isDeletingProduct}
              onYes={this.handleAcceptToDeleteProduct(true)}
              onNo={this.handleAcceptToDeleteProduct(false)}
              header="Delete Product"
              content="Are you sure you want to delete this product?"
            />
            <SharedModal
              open={this.state.showContinueModal}
              onYes={this.handleUpdateProducts(true)}
              onNo={this.handleUpdateProducts(false)}
              header="PO Status"
              content="Order has full/partial allocation, if you continue the allocation 
                       will be lost. Do you want to continue?"
            />
            <TopPanel
              isNewWorksheet={this.state.isNewWorksheet}
              enableSave={this.state.dataHasBeenModified}
              worksheetName={this.state.worksheetName}
              departments={this.state.departments}
              preTicket={this.state.preTicket}
              preTicketValue={this.state.preTicketValue}
              vendors={this.state.vendors}
              department={this.state.department}
              vendor={this.state.vendor}
              isSaving={this.state.isSaving}
              onClickSave={this.handleClickSave}
              onClickVendorCommitment={this.handleClickVendorCommitment}
              onClickCreateOrder={this.handleClickCreateOrder}
              onChangeWorksheetName={this.onChangeWorksheetName}
              onChangeDepartment={this.onChangeDepartment}
              onChangeVendor={this.onChangeVendor}
              purchaseOrderNumber={this.state.purchaseOrderNumber}
              purchaseOrderDescription={this.state.purchaseOrderDescription}
              vendorNotes={this.state.vendorNotes}
              MaycsNetRouteDate={this.state.MaycsNetRouteDate}
              CancelDate={this.state.CancelDate}
              IndcDate={this.state.IndcDate}
              DistroByDate={this.state.DistroByDate}
              onChangeDate={this.onChangeDate}
              onChangePurchaseOrderNumber={this.onChangePurchaseOrderNumber}
              onChangePurchaseOrderDescription={
                this.onChangePurchaseOrderDescription
              }
              onChangeVendorNotes={this.onChangeVendorNotes}
              onClickAddNewRow={this.handleClickAddNewRow}
              showDetailView={this.state.showDetailView}
              onToggleViewDetail={this.handleToggleViewDetail}
              inputErrors={this.state.inputErrors}
              onChangeTicketType={this.onChangeTicketType}
              ticketType={this.state.ticketType}
              ticketTypeValue={this.state.ticketTypeValue}
              disablePurchaseOrderNumber={disablePurchaseOrderNumber()}
              isVendorUpcMode={this.state.isVendorUpcMode}
              onChangeVendorUPC={this.onChangeVendorUPC}
              POIdentifiers={this.state.worksheet.POIdentifier}
              onPOIdentifierChange={this.handlePOIdentifierChange}
              isCdpProduct='false'
              isDisabled={this.state.isDisabled}
              orderStatus= {this.state.orderStatus}
            />
          </Grid.Column>
        </Grid.Row>
        
          <Grid.Row>
          <Grid.Column>
          <DataGrid
              isLoading={false}
              rows={this.state.worksheet.Products}
              dynamicMutableObjectForDataTableEditors={
                this.state.dynamicMutableObjectForDataTableEditors
              }
              onRowsUpdated={this.handleRowsUpdated}
              onSubRowsUpdated={this.handleSubRowsUpdated}
              onClickAddNewRow={this.handleClickAddNewRow}
              deleteProduct={this.handleDeleteProduct}
              isVendorUpcMode={this.state.isVendorUpcMode}
              worksheetType="ProductCreate"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            {!this.state.isLoading && (
              <Footer
                quantity={productsSummary.Quantity}
                cost={productsSummary.MBKSExtCost}
                retail={productsSummary.MBKSExtRetail}
                mu={productsSummary.MU}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
  }
      </React.Fragment>
    );
  }
}

ProductDetail.propTypes = {
  worksheetId: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./components/product-detail/ProductDetail.js